import React from "react";
import { useIntl } from "react-intl";

import { useNoJpGames } from "./use-no-jp-game";
import { useNoWagerGames } from "./use-no-wager-game";

export const NoJpWagerGames = () => {
  const intl = useIntl();
  const { noJpGames } = useNoJpGames();
  const { noWagerGames } = useNoWagerGames();

  return (
    <>
      {noWagerGames && (
        <div className="modal-info__title-mt">
          <div className="modal-info__bounceback-title">
            {intl.formatMessage({
              id: "no_wagers_game_title",
              defaultMessage:
                "A list of games in which the bonus cannot be wagered",
            })}
          </div>
          {Object.keys(noJpGames || {}).map((provider) => {
            return (
              <div key={provider} className="modal-info__game-provider">
                <div className="modal-info__game-provider-title">
                  {provider}:
                </div>
                {noWagerGames?.[provider].map((game, index) => (
                  <span
                    key={game.string_id}
                    className="modal-info__game-provider-text"
                  >
                    {game.name}
                    {noWagerGames?.[provider].length - 1 === index ? "" : ","}
                  </span>
                ))}
              </div>
            );
          })}
        </div>
      )}
      {noJpGames && (
        <div className="modal-info__title-mt">
          <div className="modal-info__bounceback-title">
            {intl.formatMessage({
              id: "no_jackpots_game_title",
              defaultMessage:
                "List of games in which the jackpot does not accumulate and cannot be received",
            })}
          </div>
          {Object.keys(noJpGames || {}).map((provider) => {
            return (
              <div key={provider} className="modal-info__game-provider">
                <div className="modal-info__game-provider-title">
                  {provider}:
                </div>
                {noJpGames?.[provider].map((game, index) => (
                  <span
                    key={game.string_id}
                    className="modal-info__game-provider-text"
                  >
                    {game.name}
                    {noJpGames?.[provider].length - 1 === index ? "" : ","}
                  </span>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
